export type AreaQueries = 'pr' | 'ci' | 'wa' | 'st';

export const AREA_QUERIES: AreaQueries[] = ['pr', 'ci', 'wa', 'st'];

export const areaQueryMap = {
  pr: 'prefectureId',
  ci: 'cityId',
  wa: 'wardId',
  st: 'stationId',
} as const;

/**
 * 検索結果一覧 近隣エリア表示パターンの絞り込みに使用するパラメーター
 */
export const nearAreaParamsMap = {
  pr: 'prefectureIdList',
  ci: 'cityIdList',
  wa: 'wardIdList',
  st: 'stationIdList',
} as const;
